var tabsExist = document.querySelectorAll(".tab_tabs");

if (tabsExist.length > 0) {
  if (typeof NodeList.prototype.forEach !== "function") {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  tabsExist.forEach(function (tabExist) {
    // console.log(tabExist);
    var tabList = tabExist.querySelector('.tablist[role="tablist"]');
    var tabs = tabExist.querySelectorAll('button.tab[role="tab"]');
    var tabPanels = tabExist.querySelectorAll('.tabpanel[role="tabpanel"]');

    var tabFocus = Array(tabs.length).fill(0); // Initialize tab focus array
    for (var j = 0; j < tabPanels.length; j++) {
      tabPanels[j].setAttribute("hidden", "true");
       if (tabs[j]) { 
    tabs[j].removeAttribute("hidden");
  }
    }

    tabs[0].setAttribute("aria-selected", "true");
    tabs[0].setAttribute("tabindex", 0);
    tabs[0].classList.add("active");
    tabPanels[0].removeAttribute("hidden");

    // Add click event listener to each tab
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => changeTabs(index, tabExist));
    });

    // Enable arrow navigation between tabs in the tab list
    tabList.addEventListener("keydown", (e) => {
      const parent = e.target.parentNode;
      const grandparent = parent.parentNode;
      const tabExistIndex = 0;

      // Move right
      if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus[tabExistIndex]].setAttribute("tabindex", -1);
        parent
          .querySelectorAll('.tab[aria-selected="true"]')
          .forEach(function (t) {
            t.setAttribute("aria-selected", false);
            t.classList.remove("active");
          });
        tabs[tabFocus[tabExistIndex]].setAttribute("aria-selected", true);
        tabs[tabFocus[tabExistIndex]].className += " active";
        grandparent
          .querySelectorAll('.tabpanel[role="tabpanel"]')
          .forEach((p) => p.setAttribute("hidden", true));

        if (e.keyCode === 39) {
          tabFocus[tabExistIndex]++;

          // If we're at the end, go to the start
          if (tabFocus[tabExistIndex] >= tabs.length) {
            tabFocus[tabExistIndex] = 0;
          }
          // Move left
        } else if (e.keyCode === 37) {
          tabFocus[tabExistIndex]--;

          // If we're at the start, move to the end
          if (tabFocus[tabExistIndex] < 0) {
            tabFocus[tabExistIndex] = tabs.length - 1;
          }
        }

        tabs[tabFocus[tabExistIndex]].setAttribute("tabindex", 0);
        parent
          .querySelectorAll('.tab[aria-selected="true"]')
          .forEach(function (t) {
            t.setAttribute("aria-selected", false);
            t.classList.remove("active");
          });
        tabs[tabFocus[tabExistIndex]].setAttribute("aria-selected", true);
        tabs[tabFocus[tabExistIndex]].className += " active";
        grandparent.parentNode
          .querySelector(
            `#${tabs[tabFocus[tabExistIndex]].getAttribute("aria-controls")}`
          )
          .removeAttribute("hidden");
        tabs[tabFocus[tabExistIndex]].focus();
      }

      //move down dow v5 qand v6
      if (tabList.parentNode.classList.contains("v5")) {
        console.log("true");
        if (e.keyCode === 40 || e.keyCode === 38) {
          tabs[tabFocus[tabExistIndex]].setAttribute("tabindex", -1);
          parent
            .querySelectorAll('.tab[aria-selected="true"]')
            .forEach(function (t) {
              t.setAttribute("aria-selected", false);
              t.classList.remove("active");
            });
          tabs[tabFocus[tabExistIndex]].setAttribute("aria-selected", true);
          tabs[tabFocus[tabExistIndex]].className += " active";
          grandparent
            .querySelectorAll('.tabpanel[role="tabpanel"]')
            .forEach((p) => p.setAttribute("hidden", true));

          if (e.keyCode === 40) {
            tabFocus[tabExistIndex]++;

            // If we're at the end, go to the start
            if (tabFocus[tabExistIndex] >= tabs.length) {
              tabFocus[tabExistIndex] = 0;
            }
            // Move left
          } else if (e.keyCode === 38) {
            tabFocus[tabExistIndex]--;

            // If we're at the start, move to the end
            if (tabFocus[tabExistIndex] < 0) {
              tabFocus[tabExistIndex] = tabs.length - 1;
            }
          }

          tabs[tabFocus[tabExistIndex]].setAttribute("tabindex", 0);
          parent
            .querySelectorAll('.tab[aria-selected="true"]')
            .forEach(function (t) {
              t.setAttribute("aria-selected", false);
              t.classList.remove("active");
            });
          tabs[tabFocus[tabExistIndex]].setAttribute("aria-selected", true);
          tabs[tabFocus[tabExistIndex]].className += " active";
          grandparent.parentNode
            .querySelector(
              `#${tabs[tabFocus[tabExistIndex]].getAttribute("aria-controls")}`
            )
            .removeAttribute("hidden");
          tabs[tabFocus[tabExistIndex]].focus();
        }
      }

      //move down dow v5 qand v6
      if (tabList.parentNode.classList.contains("v6")) {
        console.log("true");
        if (e.keyCode === 40 || e.keyCode === 38) {
          // console.log('tabfous:: ' + tabExistIndex);
          // console.log('tabExists ' + tabs[tabFocus[tabExistIndex]]);
          tabs[tabFocus[tabExistIndex]].setAttribute("tabindex", -1);
          parent
            .querySelectorAll('.tab[aria-selected="true"]')
            .forEach(function (t) {
              t.setAttribute("aria-selected", false);
              t.classList.remove("active");
            });
          tabs[tabFocus[tabExistIndex]].setAttribute("aria-selected", true);
          tabs[tabFocus[tabExistIndex]].className += " active";
          grandparent
            .querySelectorAll('.tabpanel[role="tabpanel"]')
            .forEach((p) => p.setAttribute("hidden", true));

          if (e.keyCode === 40) {
            tabFocus[tabExistIndex]++;

            // If we're at the end, go to the start
            if (tabFocus[tabExistIndex] >= tabs.length) {
              tabFocus[tabExistIndex] = 0;
            }
            // Move left
          } else if (e.keyCode === 38) {
            tabFocus[tabExistIndex]--;

            // If we're at the start, move to the end
            if (tabFocus[tabExistIndex] < 0) {
              tabFocus[tabExistIndex] = tabs.length - 1;
            }
          }

          tabs[tabFocus[tabExistIndex]].setAttribute("tabindex", 0);
          parent
            .querySelectorAll('.tab[aria-selected="true"]')
            .forEach(function (t) {
              t.setAttribute("aria-selected", false);
              t.classList.remove("active");
            });
          tabs[tabFocus[tabExistIndex]].setAttribute("aria-selected", true);
          tabs[tabFocus[tabExistIndex]].className += " active";
          grandparent.parentNode
            .querySelector(
              `#${tabs[tabFocus[tabExistIndex]].getAttribute("aria-controls")}`
            )
            .removeAttribute("hidden");
          tabs[tabFocus[tabExistIndex]].focus();
        }
      }
    });
  });
}
function changeTabs(index, tabExist) {
  const tabExistIndex = Array.from(tabsExist).indexOf(tabExist);
  const tabs = tabExist.querySelectorAll('button.tab[role="tab"]');
  const tabPanels = tabExist.querySelectorAll('.tabpanel[role="tabpanel"]');
  const target = tabs[index];
  const parent = target.parentNode;
  const grandparent = parent.parentNode;

  // Remove all current selected tabs
  parent.querySelectorAll('.tab[aria-selected="true"]').forEach(function (t) {
    t.setAttribute("aria-selected", false);
    t.classList.remove("active");
  });

  // Set this tab as selected
  target.setAttribute("aria-selected", true);
  target.className += " active";

  // Hide all tab panels
  grandparent
    .querySelectorAll('.tabpanel[role="tabpanel"]')
    .forEach((p) => p.setAttribute("hidden", true));

  // Show the selected panel
  grandparent.parentNode
    .querySelector(`#${target.getAttribute("aria-controls")}`)
    .removeAttribute("hidden");
}

// for version 7
const tabVersion7 = document.querySelector(".tab_tabs.v7");
if (tabVersion7) {
  const tabList = tabVersion7.querySelector(".tablist");
  const tabs = tabList.querySelectorAll('button.tab[role="tab"]');
  const tabPanels = tabVersion7.querySelectorAll(".tabpanel");

  tabs.forEach(function (tabsExist, index) {
    tabsExist.addEventListener("keydown", function (e) {
      if (e.keyCode === 37 || e.keyCode === 39) {
        e.preventDefault();
        let nextIndex;
        if (e.keyCode === 39) {
          nextIndex = index + 1;
        } else if (e.keyCode === 37) {
          nextIndex = index - 1;
        }

        if (nextIndex >= 0 && nextIndex < tabs.length) {
          const nextTabButton = tabs[nextIndex];
          tabs.forEach(function (tab) {
            tab.classList.remove("active");
          });

          nextTabButton.classList.add("active");

          nextTabButton.focus();
          changeTabs(nextIndex, tabVersion7);
        }
      }
    });
  });
}

// for version 7
const tabVersion8 = document.querySelector(".tab_tabs.v8");
if (tabVersion8) {
  const tabList = tabVersion8.querySelector(".tablist");
  const tabs = tabList.querySelectorAll('button.tab[role="tab"]');
  const tabPanels = tabVersion8.querySelectorAll(".tabpanel");

  tabs.forEach(function (tabsExist, index) {
    tabsExist.addEventListener("keydown", function (e) {
      if (e.keyCode === 37 || e.keyCode === 39) {
        e.preventDefault();
        let nextIndex;
        if (e.keyCode === 39) {
          nextIndex = index + 1;
        } else if (e.keyCode === 37) {
          nextIndex = index - 1;
        }

        if (nextIndex >= 0 && nextIndex < tabs.length) {
          const nextTabButton = tabs[nextIndex];
          tabs.forEach(function (tab) {
            tab.classList.remove("active");
          });

          nextTabButton.classList.add("active");

          nextTabButton.focus();
          changeTabs(nextIndex, tabVersion8);
        }
      }
    });
  });
}
